export default __webpack_public_path__ + "static/SRC 4430 - Product Specifications & Technical Data-ab2cb7faa1ffa0b6fa82bec8b135086f.pdf";